<script>
import BaseSummaryStep from '../SummaryStep'
import { dateFormatter, lang, salaryFormatter } from '../../utils'

export default {
  extends: BaseSummaryStep,

  computed: {
    summaryItems () {
      return [
        {
          label: lang.qualifications,
          value: this.form.qualifications.join(', '),
          step: 0,
        },
        {
          label: lang.linquistic_proficiency,
          value: [...this.form.languages, this.form.language_others].filter(i => i).join(', '),
          step: 1,
        },
        {
          label: lang.possible_start_of_work,
          value: dateFormatter(this.form.start_of_work),
          step: 2,
        },
        {
          label: lang.salary_expectations,
          value: salaryFormatter(this.form.expected_salary),
          step: 3,
        },
        {
          label: lang.first_name,
          value: this.form.first_name,
          step: 4,
        },
        {
          label: lang.last_name,
          value: this.form.last_name,
          step: 5,
        },
        {
          label: lang.street,
          value: this.form.street,
          step: 5,
        },
        {
          label: lang.house_number,
          value: this.form.house_number,
          step: 4,
        },
        {
          label: lang.postal_code,
          value: this.form.postal,
          step: 4,
        },
        {
          label: lang.city,
          value: this.form.city,
          step: 4,
        },
        {
          label: lang.telephone,
          value: this.form.telephone_number,
          step: 4,
        },
        {
          label: lang.email,
          value: this.form.email,
          step: 4,
        },
        {
          label: lang.additional_information,
          value: this.form.additional_information,
          step: 5,
        },
      ]
    },
  },
}
</script>